import { render, staticRenderFns } from "./FeesSynthesisTable.vue?vue&type=template&id=5a65597c"
import script from "./FeesSynthesisTable.vue?vue&type=script&lang=js"
export * from "./FeesSynthesisTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports